import { mapState, mapGetters, mapActions } from 'vuex'
// import Constants from '@/utils/Constants'
// import Utility from '@/utils/Utility'

export default {
  name: 'Item',
  props: {
    model: Object,
    serviceType: String,
  },
  data () {
    return {

    }
  },
  mounted () {
    console.log('SCL | ' + this.serviceType + ' | ' + this.model.type + ' | ' + this.model.uuid)
  },
  computed: {
    ...mapState({
      // const
      moduleType: state => state.screenConfigLayoutConst.moduleType,
      moduleSize: state => state.screenConfigLayoutConst.moduleSize
    }),
    ...mapGetters({

    }),

    label () {
      return this.moduleType.filter(item => item.value === this.model.type)[0].label
    },
    serviceTypeKey() {
      return this.serviceType === 'hoambox'
        ? 'hoambox'
        : this.serviceType === 'hoamV2'
          ? 'hoamV2'
          : 'hoam';
    },

    info() {
      const str = 'X:' + this.x
                + ' Y:' + this.y
                + '\nW:' + this.width
                + ' H:' + this.height;
      return str;
    },

    x () {
      return this.model.type === 'layoutHeader' ?
        0 : this.model.posX
    },
    y () {
      return this.model.type === 'layoutHeader' ?
        0 : this.model.posY
    },
    width () {
      switch (this.model.type) {
        case 'layoutHeader':
        case 'layoutCalendar':
          return this.moduleSize[this.model.type][this.serviceTypeKey].width
        case 'layoutWeather':
        case 'layoutFortune':
        case 'layoutList':
          return this.moduleSize[this.model.type][this.serviceTypeKey][this.model.layoutSizeType].width
        default:
          return this.model.width || 100
      }
    },
    height () {
      switch (this.model.type) {
        case 'layoutHeader':
        case 'layoutCalendar':
          return this.moduleSize[this.model.type][this.serviceTypeKey].height
        case 'layoutWeather':
        case 'layoutFortune':
        case 'layoutList':
          return this.moduleSize[this.model.type][this.serviceTypeKey][this.model.layoutSizeType].height
        default:
          return this.model.height || 100
      }
    },
    zIndex () {
      return this.model.zIndex || 0
    }
  },
  methods: {
    ...mapActions({
      // module
      showHeaderModule: 'sclHeaderModule/show',
      showSlideshowModule: 'sclSlideshowModule/show',
      showWeatherModule: 'sclWeatherModule/show',
      showFortuneModule: 'sclFortuneModule/show',
      showCalenderModule: 'sclCalenderModule/show',
      showButtonModule: 'sclButtonModule/show',
      showListModule: 'sclListModule/show',
      showLabelModule: 'sclLabelModule/show',
      showImageModule: 'sclImageModule/show',
      showPanelModule: 'sclPanelModule/show',
    }),

    modify () {
      switch (this.model.type) {
        case 'layoutHeader':
          this.showHeaderModule(this.model)
          return
        case 'layoutSlideshow':
          this.showSlideshowModule(this.model)
          return
        case 'layoutWeather':
          this.showWeatherModule(this.model)
          return
        case 'layoutFortune':
          this.showFortuneModule(this.model)
          return
        case 'layoutCalendar':
          this.showCalenderModule(this.model)
          return
        case 'layoutButton':
          this.showButtonModule(this.model)
          return
        case 'layoutList':
          this.showListModule(this.model)
          return
        case 'layoutLabel':
          this.showLabelModule(this.model)
          return
        case 'layoutImage':
          this.showImageModule(this.model)
          return
        case 'layoutPanel':
          this.showPanelModule(this.model)
          return
      }
    }
  }
}